<template>
	<BlogPosts :page="1" />
</template>
